import { type PimProductV11 } from '@redteclab/api/clients/bully'

import { productAccessorStockStatusIsAvailable } from '../../../../model/productAccessor/productAccessorStockStatusIsAvailable'
import { type SelectionEntry } from '../../../product-page-context/AttributeGroup'

type AttributeSelectionEntryVisualConditions = {
  candidateIsNotBuyable: boolean
  candidateVariant?: PimProductV11
  dontSelectCandidateOnClick: boolean
  hasManyVariants: boolean
  hasVariants: boolean
  isSelected: boolean
  notSelectedAndBuyableVariants: boolean
  notSelectedAndNoVariants: boolean
  selectedAndHasVariants: boolean
  selectedButNotBuyable: boolean
  selectedButNoVariants: boolean
  showAsLink: boolean
}

export const productPageGetAttributeSelectionEntryConditions = (
  selectionEntry: SelectionEntry,
): AttributeSelectionEntryVisualConditions => {
  const { allCandidateVariants } = selectionEntry
  const hasVariants = allCandidateVariants.length > 0
  const hasManyVariants = allCandidateVariants.length > 1
  const candidateVariant =
    allCandidateVariants.length === 1 ? allCandidateVariants[0] : undefined
  const dontSelectCandidateOnClick =
    selectionEntry.dontSelectCandidateOnClick || hasManyVariants
  const { isSelected } = selectionEntry
  const candidateIsNotBuyable = Boolean(
    candidateVariant &&
      !productAccessorStockStatusIsAvailable(candidateVariant),
  )
  const hasBuyableVariants = allCandidateVariants.some(
    productAccessorStockStatusIsAvailable,
  )

  return {
    candidateIsNotBuyable,
    candidateVariant,
    dontSelectCandidateOnClick,
    hasManyVariants,
    hasVariants,
    isSelected,
    notSelectedAndBuyableVariants: !isSelected && hasBuyableVariants,
    notSelectedAndNoVariants: !isSelected && !hasVariants,
    selectedAndHasVariants: isSelected && hasBuyableVariants,
    selectedButNotBuyable: isSelected && !hasBuyableVariants,
    selectedButNoVariants: isSelected && !hasVariants,
    showAsLink:
      Boolean(candidateVariant) && !dontSelectCandidateOnClick && !isSelected,
  }
}
